import React from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { mainURL } from '../utils/common';
import { LicenceLeftMenu } from '../components/LicenceLeftMenu';
import { LeftSocialMediaIconUI } from '../components/LeftSocialMediaIconUI';
import { DownloadFileByFileStoreId } from '../components/DownloadFileByFileStoreId';

const Eodb_Notification  = () => {
  const fileDownload=(fileStoreId)=>
  {
    
    let url=`${mainURL}/pwc-db-services/getPortalFiles`
     axios
        .post(url,{"fileId": fileStoreId, "userId": "392" })
        .then((res) => {
            console.log("response is --- ", res);

            if(res && res.data && res.status === 200) {
              const base64 = res.data[0] && res.data[0].base64_data;
              const pdfData = 'data:application/pdf;base64,'+base64;

              let html = '<html>' +
                  '<style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style>' +
                  '<body>' +
                  '<iframe src="' + pdfData + '"></iframe>' +
                  '</body></html>';
                  console.log(html);
              let a = window.open();
              a.document.write(html);
          }
        })
        .catch((e) => {
            // setLoader(false);
            console.log("The error is ", e);
        })
  }
const increaseFontSizeBy1px =() => {
    var el = document.getElementsByClassName('fontSizeClass');
    for (let i = 0; i < el.length; i++) {
      var style = window.getComputedStyle(el[i], null).getPropertyValue('font-size');
      var fontSize = parseFloat(style); 
      el[i].style.fontSize = (fontSize + 1) + 'px';
    }
  };
  const decreaseFontSizeBy1px =() => {
    var el = document.getElementsByClassName('fontSizeClass');
    for (let i = 0; i < el.length; i++) {
    var style = window.getComputedStyle(el[i], null).getPropertyValue('font-size');
    var fontSize = parseFloat(style); 
    el[i].style.fontSize = (fontSize - 1) + 'px'; 
    }
  };
  const { t, i18n, ready } = useTranslation();
  return (
    <>
  <section id="hero" className="hero hero2">
  <LeftSocialMediaIconUI />
    
    <div className="carousel-item active">
      <img src="assets/img/inner-bg2.png" className="img-fluid" alt="image" />      
    </div>
  </section>
  <section className="section inner-pad1">
    <div className="container " >
      <div className="row">
      <div className="col-lg-3">
          <div className="site-menu  min-height-400">
            <LicenceLeftMenu />
          </div>
        </div>
        <div className="col-lg-9">
         <div className="container">
          <div className="row">
            <div className="inner-title2">
              <h3 className="fontSizeClass"> {t("EODB - License - Notification")} </h3>
            </div>
            <div className="col-lg-12 about-head1 mt-4">
              <div className='position-relative map2'>
                <DownloadFileByFileStoreId fileStoreId={""} label={"725 MA Revised Enlistment Trade Calling"} classAdd={false} />
               </div>
               <div className='position-relative map2'>
                <DownloadFileByFileStoreId fileStoreId={""} label={"Exemption under sec 5(1)(a) under S & E Act"} classAdd={false} />
               </div>
               <div className='position-relative map2'>
                <DownloadFileByFileStoreId fileStoreId={""} label={"Notice of overtime"} classAdd={false} />
               </div>
               <div className='position-relative map2'>
                <DownloadFileByFileStoreId fileStoreId={""} label={"Restriction of inspection prior to registration"} classAdd={false} />
               </div>
               <div className='position-relative map2'>
                <DownloadFileByFileStoreId fileStoreId={""} label={"Self Certification"} classAdd={false} />
               </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</>

  )
}

export default Eodb_Notification